import { render, staticRenderFns } from "./ColumnsBlock.vue?vue&type=template&id=2a754b77&scoped=true&"
import script from "./ColumnsBlock.vue?vue&type=script&lang=js&"
export * from "./ColumnsBlock.vue?vue&type=script&lang=js&"
import style0 from "./ColumnsBlock.vue?vue&type=style&index=0&id=2a754b77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a754b77",
  null
  
)

export default component.exports